/**
 * @generated SignedSource<<cfc152d06332301e69f64c44d88219be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PermissionType = "ADMIN" | "NONE" | "READ" | "WRITE" | "%future added value";
export type GenerateNewScopedAccessTokenInput = {
  clientMutationId: string;
  durationSeconds?: number | null;
  ownerUid: string;
  permission: PermissionType;
  platform: string;
  repositoryNames: ReadonlyArray<string>;
};
export type OwnerScopedTokenDialogMutation$variables = {
  input: GenerateNewScopedAccessTokenInput;
};
export type OwnerScopedTokenDialogMutation$data = {
  readonly generateNewScopedAccessToken: {
    readonly token: string;
  };
};
export type OwnerScopedTokenDialogMutation = {
  response: OwnerScopedTokenDialogMutation$data;
  variables: OwnerScopedTokenDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateNewScopedAccessTokenPayload",
    "kind": "LinkedField",
    "name": "generateNewScopedAccessToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OwnerScopedTokenDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OwnerScopedTokenDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff7b576c96bd43d929fafe4d9700885a",
    "id": null,
    "metadata": {},
    "name": "OwnerScopedTokenDialogMutation",
    "operationKind": "mutation",
    "text": "mutation OwnerScopedTokenDialogMutation(\n  $input: GenerateNewScopedAccessTokenInput!\n) {\n  generateNewScopedAccessToken(input: $input) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "141d511c8e86e1b3b1abd82aba521ff9";

export default node;
